import { Modal } from 'react-bootstrap';

interface ImageViewerModalProps {
  show: boolean;
  imageUrl: string | null;
  onHide: () => void;
}

export const ImageViewerModal = ({ show, imageUrl, onHide }: ImageViewerModalProps) => {
  if (!imageUrl) return null;

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Body className="p-0 text-center bg-dark">
        <img
          src={imageUrl}
          alt="이미지"
          style={{
            maxWidth: '100%',
            maxHeight: '80vh',
            objectFit: 'contain',
          }}
          onClick={onHide}
        />
      </Modal.Body>
    </Modal>
  );
};
